<template>
  <a-card :bordered="false">
    <search-page-view
      :col="2"
      ref="pageList"
      :itemNames="['search_id','search_name']"
      :columns="columns"
      :queryParams="queryParams"
      row-key="fissionId"
      :leftSpace="30"
      :enable-search="false"
      :requestPromise="getListPromise"
    >
      <a-form-item slot="search_id" label="活动ID" v-bind="searchItemLayout">
        <a-input v-model="queryParams.fissionId" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="search_name" label="活动名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.fissionTitle" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="operation">
        <a-button style="margin-left: 150px" type="primary" @click="$refs.pageList.refresh()">查询</a-button>
        <a-button style="margin-left: 20px" @click="toCreate('',false)">新建</a-button>
      </a-form-item>
      <span slot="fissionStatus" slot-scope="rowItem">
        {{ rowItem.record.fissionStatus|fissionStatus }}
      </span>
      <span slot="action" slot-scope="rowItem">
        <span v-if="rowItem.record.fissionStatus==2||rowItem.record.fissionStatus==3">
            <a @click="toCreate(rowItem.record,true)">查看</a>
          <span v-if="rowItem.record.fissionStatus==2">
            <a-divider type="vertical"></a-divider>
            <a @click="changeStatus(rowItem.record)">下线</a>
          </span>
        </span>
        <span v-if="rowItem.record.fissionStatus==1">
          <a @click="changeStatus(rowItem.record)">投放</a>
          <a-divider type="vertical"></a-divider>
          <a @click="toCreate(rowItem.record,false)">编辑</a>
          <a-divider type="vertical"></a-divider>
          <a-popconfirm
            title="确认删除本条数据吗？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="onDelete(rowItem.record)"
          >
              <a style="color:red">删除</a>
          </a-popconfirm>
        </span>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import searchForm from '../../../../utils/mixins/searchFormMixins'

export default {
  name: 'FissionRedEnvelope',
  mixins: [searchForm],
  data() {
    return {
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      queryParams: {},
      columns: [
        {
          title: '活动ID',
          dataIndex: 'fissionId'
        },
        {
          title: '活动名称',
          dataIndex: 'fissionTitle'
        },
        {
          title: '状态',
          dataIndex: 'fissionStatus',
          scopedSlots: { customRender: 'fissionStatus' }
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '240px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'FissionRedEnvelope', title: '活动列表' }
    ])
  },
  methods: {
    getListPromise(params) {
      params.merchantId = this.merchantId
      params.platformId = this.platformId
      return this.getHttpServices().getServerApiService().post('fission/list', params)
    },
    onDelete(record) {
      this.getHttpServices().getServerApiService().get('fission/delete?fissionId=' + record.fissionId)
        .then(res => {
          this.$message.success('删除成功')
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    changeStatus(record) {
      let params = {
        merchantId: this.merchantId,
        platformId: this.platformId,
        fissionId: record.fissionId,
        fissionStatus: record.fissionStatus + 1
      }
      this.getHttpServices().getServerApiService().post('fission/updateStatus', params)
        .then(res => {
          this.$message.success('操作成功')
          this.$refs.pageList.refresh(true)
        })
        .catch(reason => this.showNetWorkErrorMessage(reason))
    },
    toCreate(record, isExamine) {
      let query = {
        serverId: this.$route.query.serverId,
        serverUniqueId: this.$route.query.serverUniqueId
      }
      if (record.fissionId) {
        query.fissionId = record.fissionId
      }
      if (isExamine) {
        query.isExamine = true
      }
      this.openNewPage('AddRedEnvelope', query)
    }
  }
}
</script>

<style scoped>

</style>